import './Privacy.css';
const Comp=(props)=>{
    return (
        <div className="grey_strip">
        <p>{props.head}</p>
        </div>
    );
};
export default Comp;